import type { PercentileCurvePoint } from './types'

export type DotColor = 'green' | 'yellow' | 'red'

export function interpolatePercentile(
  percentiles: PercentileCurvePoint[],
  month: number
): PercentileCurvePoint | null {
  if (percentiles.length === 0) return null
  const lower = [...percentiles].reverse().find((p) => p.month <= month)
  const upper = percentiles.find((p) => p.month > month)
  if (!lower && !upper) return null
  if (!lower) return upper ?? null
  if (!upper) return lower
  const t = (month - lower.month) / (upper.month - lower.month)
  return {
    month,
    p3: lower.p3 + t * (upper.p3 - lower.p3),
    p15: lower.p15 + t * (upper.p15 - lower.p15),
    p50: lower.p50 + t * (upper.p50 - lower.p50),
    p85: lower.p85 + t * (upper.p85 - lower.p85),
    p97: lower.p97 + t * (upper.p97 - lower.p97)
  }
}

export function classifyPoint(
  value: number,
  pct: PercentileCurvePoint
): DotColor {
  if (value >= pct.p15 && value <= pct.p85) return 'green'
  if (
    (value >= pct.p3 && value < pct.p15) ||
    (value > pct.p85 && value <= pct.p97)
  ) {
    return 'yellow'
  }
  return 'red'
}
